<div class="collapsible{tag}">
	{#if header !== ""}
        <svelte:element this={tag}>
            <button aria-expanded={expanded} onclick={() => expanded = !expanded}>
                {header}
                <svg viewBox="0 0 20 20" fill="none" >
                    <path class="vert" d="M10 1V19" stroke="grey" stroke-width="2"/>
                    <path d="M1 10L19 10" stroke="grey" stroke-width="2"/>
                </svg>
            </button>
        </svelte:element>
	{/if}

	<div class='contents' hidden={!expanded}>
        {@render children?.()}
	</div>
</div>


<script>
	// based on suggestions from:

    let {header, tag = 'h2', expanded = (header === ""), children} = $props();
</script>


<style lang="sass">
	@use "../colors" as colors

	h2
		margin: 0

	button
		background: none
		color: colors.$white
		display: flex
		justify-content: space-between
		width: 100%
		border: none
		margin: 0
		padding: 0.5em

	button[aria-expanded="true"] .vert
		display: none

	button:focus svg
		outline: 2px solid grey

	button [aria-expanded="true"] rect
		fill: grey

	svg
		height: 0.7em
		width: 0.7em

</style>